import { format, parseISO } from 'date-fns';

import { AnalyticsGranularity } from 'shared/api';

const GRANULARITY_FORMAT: Record<AnalyticsGranularity, string> = {
  day: 'd MMM',
  week: 'd MMM',
  month: 'MMM yyyy',
  'half-year': 'MMM yyyy',
};

export const formatBucket = (iso: string, granularity: AnalyticsGranularity): string => {
  try {
    return format(parseISO(iso), GRANULARITY_FORMAT[granularity]);
  } catch {
    return iso;
  }
};

export const toApiDate = (date: Date | null): string | undefined => (date ? format(date, 'yyyy-MM-dd') : undefined);

export const fromApiDate = (s: string | null | undefined): Date | null => {
  if (!s) return null;
  const d = parseISO(s);
  return Number.isNaN(d.getTime()) ? null : d;
};
